<spinner *ngIf="loading"></spinner>

<cdss-patient-detail-header
    *ngIf="patient"
    [patientId]="id"
    [patient]="patient"
    [careProgramTitle]="userCareProgram?.careProgram?.title ?? null"
    (goBack)="goBackToDashboard()">
    <button headerActions class="btn btn-ghost" (click)="showRecords()" *ngIf="patient?.user.category != 'NHS'">
        <i class="bi bi-journal-text"></i> Records
    </button>
</cdss-patient-detail-header>

<div *ngIf="!records">
    <div class="patient-container">
        <div class="d-flex justify-content-between align-items-center">
            <cdss-pill-tabs
                [tabs]="tabs"
                [activeId]="activeTab"
                (activeIdChange)="onActiveTabChange($event)">
            </cdss-pill-tabs>

            <cdss-week-card-selector
                [weeks]="userCareProgram?.config?.weeks ?? []"
                [selectedWeekNumber]="selectedWeekNumber"
                [adherenceByWeek]="visibleAdherenceByWeek"
                [loadingWeekNumbers]="loadingWeekNumbers"
                (weekSelected)="onWeekChange($event)"
                (visibleRangeChanged)="onVisibleRangeChanged($event)">
            </cdss-week-card-selector>
        </div>
    </div>

    <div class="patient-wrapper">
        <ng-container *ngIf="activeTab === 1">
            <div class="patient-content">
                <div class="d-flex align-items-center gap-4 mb-2">
                    <h3 class="mb-0">Weekly Summary</h3>
                    <button class="view-more-link" *ngIf="selectedWeek" (click)="navigateToPatientWeeklyDetail()">
                        View more <span class="view-more-link__circle"><i class="bi bi-chevron-right"></i></span>
                    </button>
                </div>
                <cdss-patient-overview-v2-weekly-summary type="patient" [currentWeek]="selectedWeek" [careProgramId]="userCareProgram?.id ?? null"></cdss-patient-overview-v2-weekly-summary>
            </div>
            <div class="patient-content">
                <h3>Timeline</h3>
                <cdss-patient-overview-v2-timeline [currentWeek]="selectedWeek" [patientId]="id"></cdss-patient-overview-v2-timeline>
            </div>
            <cdss-patient-overview-v2-adherence [currentWeek]="selectedWeek" type="patient"></cdss-patient-overview-v2-adherence>
            <cdss-patient-overview-v2-footer [patient]="patient" type="patient"></cdss-patient-overview-v2-footer>
        </ng-container>

        <ng-container *ngIf="activeTab === 2">
            <div class="patient-content">
                <div class="d-flex align-items-center gap-4 mb-2">
                    <h3 class="mb-0">Weekly Summary</h3>
                    <button class="view-more-link" *ngIf="selectedWeek" (click)="navigateToCarerWeeklyDetail()">
                        View more <span class="view-more-link__circle"><i class="bi bi-chevron-right"></i></span>
                    </button>
                </div>
                <cdss-patient-overview-v2-weekly-summary type="carer" [currentWeek]="selectedWeek" [careProgramId]="userCareProgram?.id ?? null" [isArfid]="isArfid"></cdss-patient-overview-v2-weekly-summary>
            </div>
            <div class="patient-content">
                <h3>Timeline</h3>
                <cdss-patient-overview-v2-timeline [currentWeek]="selectedWeek" type="carer" [patientId]="id"></cdss-patient-overview-v2-timeline>
            </div>
            <cdss-patient-overview-v2-adherence [currentWeek]="selectedWeek" type="carer"></cdss-patient-overview-v2-adherence>
            <cdss-patient-overview-v2-footer [patient]="patient" type="carer"></cdss-patient-overview-v2-footer>
        </ng-container>
    </div>

</div>

<div style="padding-top:100px" *ngIf="records">
    <cdss-patient-records [patientId]="id" (close)="hideRecords()"></cdss-patient-records>
</div>
